<template>
	<div id="app">
		<v-app id="inspire">
            <v-flex xs12 md12 lg12>
            <v-toolbar flat class="elevation-1" fixed dark color="blue-grey darken-4">
                <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
                
                <v-layout>
                    <v-flex class="overflow-hidden">
                        <!-- <div id="logo-container">
                            <img onclick="window.location.href = window.location.origin+'/branch-locator';" width="500" height="600" :src="require('../assets/TCM-LOGO-WHITE.png')"/>
                        </div> -->
                        <img onclick="window.location.href = window.location.origin+'/branch-locator';" width="300" height="100" class="pt-1" style="vertical-align:middle" :src="require('../assets/TCM-LOGO-WHITE.png')"/>
                    </v-flex>
                </v-layout>

                <v-spacer></v-spacer>
                <v-menu v-if="user" offset-y class="hidden-sm-and-down">
                    <template v-slot:activator="{ on }">
                        <v-btn dark flat v-if="user" v-on="on" class="hidden-sm-and-down subheading font-weight-medium justify-center">
                            <div v-if="user.fullName">Hi, {{user.fullName}}</div>
                            <div v-else>Hi, {{user.email}}</div>
                            <v-spacer></v-spacer>
                            <v-icon>arrow_drop_down</v-icon>
                        </v-btn>
                    </template>

                    <v-card dark>
                        <v-list class="blue-grey darken-4">
                            <v-list-tile avatar>
                                <v-list-tile-avatar>
                                    <v-avatar v-if="user.photo">
                                        <img :src="user.photo">
                                    </v-avatar>
                                    <v-avatar v-else>
                                        <v-icon size="40">portrait</v-icon>
                                    </v-avatar>
                                </v-list-tile-avatar>
                    
                                <v-list-tile-content>
                                    <v-list-tile-title class="dark">{{user.email}}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                
                        <v-divider></v-divider>

                        <v-list class="blue-grey darken-4">
                            <v-list-tile onclick="window.location.href = window.location.origin+'/branch-locator';">
                                <v-list-tile-action><v-icon color="green lighten-1">location_on</v-icon></v-list-tile-action>
                                <v-list-tile-content>
                                <v-list-tile-title class="body-2 font-weight-medium">BOOK</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile @click="(goToPage('transactions'))">
                                <v-list-tile-action><v-icon color="green lighten-1">dashboard</v-icon></v-list-tile-action>
                                <v-list-tile-content>
                                <v-list-tile-title class="body-2 font-weight-medium">TRANSACTIONS</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                
                            <v-list-tile v-if="email !=''" @click="profileDialog=true">
                                <v-list-tile-action class="body-2 font-weight-medium"><v-icon color="green lighten-1">person</v-icon></v-list-tile-action>
                                <v-list-tile-content>
                                <v-list-tile-title class="body-2 font-weight-medium">MY PROFILE</v-list-tile-title> 
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile v-if="user" class="mt-3" @click="(goToPage('logout'),drawer=false)">
                                <v-list-tile-action>
                                <v-icon color="grey darken-1">exit_to_app</v-icon></v-list-tile-action>
                                <v-list-tile-title class="body-2 font-weight-medium grey--text text--darken-1">LOGOUT</v-list-tile-title>
                            </v-list-tile>
                            
                            <v-list-tile v-else class="mt-3" @click="(goToPage('login'),drawer=false)">
                                <v-list-tile-action>
                                <v-icon color="grey darken-1">exit_to_app</v-icon></v-list-tile-action>
                                <v-list-tile-title class="body-2 font-weight-medium grey--text text--darken-1">LOGIN</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-card>
                </v-menu>

                <v-btn v-else dark flat class="hidden-sm-and-down subheading font-weight-medium justify-center" @click="(goToPage('login'),drawer=false)">
                    <v-spacer></v-spacer>
                    LOGIN
                </v-btn>
			</v-toolbar>

            <!-- <v-toolbar v-if="updateNotification" app dark color="error" class="mt-5 elevation-1" style="top: 16px; opacity: 0.85" > 
                <v-toolbar-title class="title font-weight-medium justify-center">
                    <v-icon color="warning">warning</v-icon> Please update your account details
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn light @click="profileDialog=true">
                    Update profile
                </v-btn>
            </v-toolbar> -->

            <v-navigation-drawer :clipped="true" app hide-overlay class="blue-grey darken-4 hidden-md-and-up" v-model="drawer" temporary id="drawer">
                <v-list flat dark>
                    <v-card-title v-if="user" class="subheading font-weight-medium">
                        <div v-if="user.fullName">Hi, {{user.fullName}}</div>
                        <div v-else>Hi, {{user.email}}</div>
                        <v-list-tile-avatar class="justify-center">
                            <img v-if="user.photo" :src="user.photo">
                        </v-list-tile-avatar>
                    </v-card-title>

                    <v-list-tile onclick="window.location.href = window.location.origin+'/branch-locator';">
                        <v-list-tile-action><v-icon color="green lighten-1">location_on</v-icon></v-list-tile-action>
                        <v-list-tile-content>
                        <v-list-tile-title>BOOK</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile @click="(goToPage('transactions'))">
                        <v-list-tile-action><v-icon color="green lighten-1">dashboard</v-icon></v-list-tile-action>
                        <v-list-tile-content>
                        <v-list-tile-title>TRANSACTIONS</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile v-if="email !=''" @click="profileDialog=true">
                        <v-list-tile-action><v-icon color="green lighten-1">person</v-icon></v-list-tile-action>
                        <v-list-tile-content>
                        <v-list-tile-title>MY PROFILE</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile v-if="user" class="mt-3" @click="(goToPage('logout'),drawer=false)">
                        <v-list-tile-action>
                        <v-icon color="grey darken-1">exit_to_app</v-icon></v-list-tile-action>
                        <v-list-tile-title class="grey--text text--darken-1">LOGOUT</v-list-tile-title>
                    </v-list-tile>
                    
                    <v-list-tile v-else class="mt-3" @click="(goToPage('login'),drawer=false)">
                        <v-list-tile-action>
                        <v-icon color="grey darken-1">exit_to_app</v-icon></v-list-tile-action>
                        <v-list-tile-title class="grey--text text--darken-1">Login</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-navigation-drawer>
            </v-flex>

            <div><v-dialog v-model="profileDialog" fullscreen max-width="80%" max-height="100%">
                <v-card color="grey lighten-5">
                    <v-toolbar fixed dark color="blue-grey darken-4">
                        <v-toolbar-title>MY ACCOUNT</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="profileDialog=false">
                        <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-img height="200px" :src="require('../img/matt-boitor-1390290-unsplash.jpg')">
                        <v-card-title class="white--text justify-center">
                            <div class="display-1 pl-10 pt-50">
                            My Account
                            </div>
                        </v-card-title>
                        
                         <v-layout>
                            <v-flex xs12 v-if="user">
                                <v-container class="hidden-md-and-up">
                                <v-flex xs12 class="left">
                                    <v-list-tile-avatar size="100px" class="justify-center">
                                        <img v-if="user.photo" :src="user.photo">
                                        <v-icon v-else size="100px">person</v-icon>
                                    </v-list-tile-avatar>
                                </v-flex>
                                </v-container>
                            </v-flex>
                        </v-layout>
                    </v-img>

                    <v-container>
                        <v-layout>
                            <v-flex xs12 md9>
                                <v-card>
                                    <v-card-title primary-title class="headline blue-grey darken-3 font-weight-medium white--text">
                                        <div> <h3 class="headline mb-0">PERSONAL PROFILE</h3></div>
                                    </v-card-title>

                                    <v-card-text v-if="user">
                                        <v-flex xs12 class="font-weight-regular subheading"><b>Email : </b> {{user.email}} </v-flex>
                                        <v-flex xs12 class="font-weight-regular subheading"><b>Name : </b> {{user.fullName}} </v-flex>
                                        <v-flex xs12 class="font-weight-regular subheading"><b>Address : </b> {{user.address.brgy}} {{user.address.city}} {{user.address.state}}</v-flex>
                                        <v-flex xs12 class="font-weight-regular subheading"><b>Mobile Number : </b>{{user.mobileNumber}} </v-flex>
                                        <!-- <v-flex xs12 class="font-weight-regular subheading"><b>TIN : </b>{{user.tin}} </v-flex> -->
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-btn flat color="orange" @click="openProfileDialog()">Update</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>

                            <v-flex xs1 class="hidden-sm-and-down"></v-flex>

                            <v-flex xs2 class="hidden-sm-and-down" v-if="user">
                                <v-container>
                                    <v-flex xs12 class="justify-center">
                                        <v-list-tile-avatar size="150px" class="justify-center">
                                            <img v-if="user.photo" :src="user.photo">
                                            <v-icon v-else size="150px">person</v-icon>
                                        </v-list-tile-avatar>
                                    </v-flex>
                                </v-container>
                            </v-flex>
                        </v-layout>
                        <br>
                        <v-layout>
                            <v-flex xs12 md12 style="overflow: auto">
                                <v-card-title primary-title class="headline blue-grey darken-3 font-weight-medium white--text">
                                    <div> <h3 class="headline mb-0">MOTORCYCLE PROFILE</h3></div>
                                    <v-spacer></v-spacer> 
                                    <v-btn v-if="mobileNumber.length==10" color="deep-orange" dark @click="openMotorcycleDialog()">Add Motorcycle</v-btn>
                                </v-card-title>
                                <v-data-table :headers="headers" :items="motorcycles" class="elevation-3" :hide-default-footer="true">    
                                    <template v-slot:items="props">
                                        <td>{{ props.item.dealer }}</td>
                                        <td class="text-xs-left">{{ props.item.make }}</td>
                                        <td class="text-xs-left">{{ props.item.classification }}</td>
                                        <td class="text-xs-left">{{ props.item.model }}</td>
                                        <td class="text-xs-left">{{ props.item.yearModel }}</td>
                                         <td class="text-xs-left">{{ props.item.color }}</td>
                                        <td class="text-xs-left">{{ props.item.engineNumber }}</td>
                                        <td class="text-xs-left">{{ props.item.chassisNumber }}</td>
                                        <td class="text-xs-left">{{ props.item.plateNumber }}</td>
                                        <td class="text-xs-left">{{ props.item.odometer }}</td>
                                        <td class="text-xs-left">{{ props.item.dateOfPurchase }}</td>
                                        <td class="text-xs-left">{{ props.item.registrationDate }}</td>
                                        <td class="text-xs-center">
                                            <v-icon @click="viewHistory(props.item)">more_horiz</v-icon>
                                        </td>
                                    </template> 
                                </v-data-table>
                            </v-flex>
                        </v-layout> 

                        <v-dialog v-model="userProfileDialog" persistent max-width="1000px">
                            <v-card>
                                <v-parallax dark class="blue-grey darken-4" height="70">
                                    <v-container>
                                        <v-layout>
                                            <h4 class="subheading font-weight-medium">UPDATE PROFILE</h4>
                                        </v-layout>
                                    </v-container>
                                </v-parallax> 
                            
                                <v-card-text>
                                    <v-container grid-list-md class="pt-0">
                                        <v-layout wrap>
                                            <v-flex xs6>
                                                <v-flex xs12>
                                                    <v-text-field v-model="firstName" hide-details label="First Name*"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-text-field v-model="middleName" hide-details label="Middle Name"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-text-field v-model="lastName" hide-details label="Last Name*"></v-text-field>
                                                </v-flex>

                                                <v-layout>
                                                    <v-flex xs3>
                                                        <v-text-field label="Country Code" hide-details readonly type="text" required value="+63" ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs9>
                                                        <v-text-field v-model="mobileNumber" hide-details :rules="mobileChecker" label="Mobile Number*" maxlength="10" type="text" required hint=" ex.9123456789"></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs6>
                                                <v-flex xs12>
                                                    <v-text-field v-model="address.brgy" hide-details label="Barangay*"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-text-field v-model="address.city" hide-details label="City*"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-text-field v-model="address.state" hide-details label="Province*"></v-text-field>
                                                </v-flex>

                                                <!-- <v-flex xs12>
                                                    <v-text-field v-model="tin" hide-details label="TIN"></v-text-field>
                                                </v-flex> -->
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                    <v-layout justify-center>
                                        <v-card-actions>
                                            <v-btn dark color="red accent-4" @click="closeProfileDialog()">Close</v-btn>
                                            <v-btn dark color="blue darken-4" @click="saveUserDetails()">Save</v-btn>
                                        </v-card-actions>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                    </v-dialog>

                    <v-dialog v-model="motorcycleDetailsDialog" persistent max-width="600px">
                        <motorcycle-component></motorcycle-component>
                    </v-dialog>
                    </v-container>
                </v-card>
            </v-dialog></div>

            <v-dialog v-model="progressDialog" persistent width="300">
                <v-card color="blue-grey darken-4">
                    <v-card-text class="subheading white--text"> Updating Profile
                        <v-layout row justify-center>
                        <v-progress-linear :indeterminate="true" :size="70" :width="5" color="white"
                        ></v-progress-linear>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog v-model="editMotorcyleDialog" persistent max-width="600px">
                <v-card>
                    <v-parallax dark class="blue-grey darken-3 pb-0" height="70">
                        <v-spacer></v-spacer>
                        <v-container>
                            <v-layout><br>
                                <h4 class="subheading font-weight-medium">UPDATE MOTORCYCLE</h4>
                            </v-layout>
                        </v-container>
                    </v-parallax>

                    <v-container grid-list>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-autocomplete v-model="forChangeMotorcycle.dealer"  label="Dealer" :items="dealers" persistent-hint hide-no-data leave-absolute hide-details>
                                    <template v-slot:append-outer>
                                        <v-slide-x-reverse-transition mode="out-in">
                                        </v-slide-x-reverse-transition>
                                    </template>
                                </v-autocomplete>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-select v-model="forChangeMotorcycle.classification" label="Classification*" required :items="classifications" hide-details readonly
                                ></v-select>
                            </v-flex>

                            <v-flex xs12>
                                <v-autocomplete v-model="forChangeMotorcycle.make"  label="Make*" :items="brands" persistent-hint hide-no-data hide-details leave-absolute readonly>
                                    <template v-slot:append-outer>
                                        <v-slide-x-reverse-transition mode="out-in">
                                        </v-slide-x-reverse-transition>
                                    </template>
                                </v-autocomplete>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field label="Model*" v-model='forChangeMotorcycle.model' hide-details required readonly></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field label="Year Model" v-model='forChangeMotorcycle.yearModel' hide-details placeholder="Optional"></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field label="Color" v-model='forChangeMotorcycle.color' hide-details placeholder="Optional"></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field label="Engine Number" v-model='forChangeMotorcycle.engineNumber' hide-details placeholder="Optional"></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field label="Chassis Number" v-model='forChangeMotorcycle.chassisNumber' hide-details placeholder="Optional"></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field label="Plate Number" v-model='forChangeMotorcycle.plateNumber' hide-details placeholder="Optional"></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field label="Date of Purchase" v-model='forChangeMotorcycle.dateOfPurchase' hide-details placeholder="Optional"></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field label="Registartion Date" v-model='forChangeMotorcycle.registrationDate' hide-details placeholder="Optional"></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field label="Mileage(km)" v-model='forChangeMotorcycle.odometer' required hide-details readonly placeholder="Optional"></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout justify-center>
                            <v-btn dark color="red accent-4" @click="editMotorcyleDialog=false,fetchMcDetails()">Cancel</v-btn>
                            <v-btn dark color="blue darken-4" @click="updateMotorcycle(forChangeMotorcycle)">Save</v-btn>
                        </v-layout>
                    </v-container> 
                </v-card>
            </v-dialog>

            <v-dialog v-model="motorcycleHistoryDialog" fullscreen>
                <v-card>
                    <v-parallax dark class="blue-grey darken-4" height="70">
                        <v-spacer></v-spacer>
                        <v-layout><br>
                            <v-card-title class="title font-weight-medium pt-1">MY VEHICLE</v-card-title>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="motorcycleHistoryDialog = false"> <v-icon color="deep-orange">close</v-icon> </v-btn>
                        </v-layout> 
                    </v-parallax>

                    <v-container grid-list>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-card color="blue-grey darken-3" dark>
                                    <v-layout row>
                                        <v-flex xs4>
                                            <v-card-title primary-title>
                                                <div>
                                                    <div class="display-1 font-weight-bold">{{selectedMotorcycle.model}}</div>
                                                    <div class="title font-weight-medium">{{selectedMotorcycle.make}}</div>
                                                    <div class="subheading font-weight-medium">{{selectedMotorcycle.yearModel}}</div><br>
                                                    <div class="subheading font-weight-medium">{{selectedMotorcycle.odometer}} km</div>
                                                    <div class="body font-weight-light">Last Service Mileage</div>
                                                </div>
                                            </v-card-title> 
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-card-title primary-title>
                                                <div>
                                                    <div class="title font-weight-bold pt-1">{{selectedMotorcycle.color}}</div>
                                                    <div class="body font-weight-light pb-2" >Color</div>
                                                    <div class="title font-weight-bold">{{selectedMotorcycle.engineNumber}}</div>
                                                    <div class="body font-weight-light pb-2" >Engine Number</div>
                                                    <div class="title font-weight-bold">{{selectedMotorcycle.chassisNumber}}</div>
                                                    <div class="body font-weight-light pb-2">Chassis Number</div>
                                                    <div class="title font-weight-bold">{{selectedMotorcycle.plateNumber}}</div>
                                                    <div class="body font-weight-light">Plate Number</div>
                                                </div>
                                            </v-card-title> 
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-card-title primary-title>
                                                <div>
                                                    <div class="title font-weight-bold pt-1">{{selectedMotorcycle.classification}}</div>
                                                    <div class="body font-weight-light pb-2" >Classification</div>
                                                    <div class="title font-weight-bold">{{selectedMotorcycle.dateOfPurchase}}</div>
                                                    <div class="body font-weight-light pb-2">Purchase Date</div>
                                                    <div class="title font-weight-bold">{{selectedMotorcycle.registrationDate}}</div>
                                                    <div class="body font-weight-light">Registration Date</div>
                                                </div>
                                            </v-card-title> 
                                        </v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn dark color="deep-orange" outline @click="requestForChange(selectedMotorcycle)">UPDATE</v-btn>
                                        <v-btn dark color="deep-orange" @click="deleteMotorcycleRequest(selectedMotorcycle)">Delete</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout><br>

                        <v-layout>
                            <v-flex xs12 md12 style="overflow: auto">
                                <v-card-title primary-title class="headline blue-grey darken-3 font-weight-bold white--text"> SERVICE HISTORY
                                </v-card-title>
                            </v-flex>
                        </v-layout>

                        <v-layout>
                            <v-flex xs12 v-if="serviceHistory.length > 0">
                                <v-timeline align-top dense>
                                    <v-timeline-item  v-for="(list, index) in serviceHistory" :key="index" color="green darken-2" icon="check" small>
                                        <v-layout pt-3>
                                            <v-flex xs12>
                                                <strong>{{list.formatedDate}}</strong>
                                                <div v-for="(service, index2) in list.initialService" :key="index2">{{service.displayName}}</div>
                                                <div><strong>{{list.branch}}</strong></div>
                                                <div>{{list.mechanic}}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-timeline-item>
                                </v-timeline>
                            </v-flex>

                            <v-flex xs12 v-else>
                                <div class="text-xs-center"> <br><br><br>
                                    <v-card-title class="headline font-weight-bold justify-center">NO SERVICE HISTORY
                                    </v-card-title>
                                </div>
                            </v-flex> 
                        </v-layout> 
                    </v-container>
                </v-card>
            </v-dialog>

            <v-dialog v-model="removeMotorcycleDialog" max-width="500px">
                <v-card>
                    <v-card-title class="title font-weight-regular">
                        Are you sure you want to remove this motorcycle in the list?
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-title class="subheading font-weight-regular justify-center">
                        You are about to remove the motorcycle details in the list.
                        <br>Do you want to proceed?
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-end">
                        <v-btn dark color="grey darken-1" @click="removeMotorcycleDialog=false">NO</v-btn>
                        <v-btn dark color="blue darken-4" @click="(deleteMotorCycle(forChangeMotorcycle))">YES</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-snackbar v-model="showAlert" bottom right :color="alertColor">{{alertMessage}}
                <v-btn dark small flat @click="showAlert = false">Close</v-btn>
            </v-snackbar>

            <v-content>
                <v-layout>
                    <v-flex>
                        <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                </v-layout>
            </v-content>
		</v-app>
	</div>
</template>

<script>
import firebase from "firebase"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { mapGetters, mapActions, mapState } from "vuex"
import { db } from '../main.js'
import _ from 'lodash'
import motorcycleComponent from './Motorcycle.vue'
 
export default {
    components: {
        motorcycleComponent
    },
	data: () => ({
        drawer : null,
        profileDialog: false,
        email: "",
        emailRules: [v => !!v || 'Email is required', v => /.+@.+/.test(v) || 'Email must be valid'],
        dealers: [],
        brands: [],
        headers: [
            { text: 'Dealer', sortable: false, value: 'dealer'},
            { text: 'Make', value: 'make',  sortable: false  },
            { text: 'Classification', value: 'classification',  sortable: false  },
            { text: 'Model', value: 'model',  sortable: false  },
            { text: 'Year', value: 'year',  sortable: false  },
            { text: 'Color', value: 'color',  sortable: false  },
            { text: 'Engine Number', value: 'engineNumber',  sortable: false  },
            { text: 'Chassis Number', value: 'chassisNumber',  sortable: false  },
            { text: 'Plate Number', value: 'plateNumber',  sortable: false  },
            { text: 'Mileage', value: 'odometer',  sortable: false  },
            { text: 'Date of Purchase', value: 'dateOfPurchase',  sortable: false  },
            { text: 'Registration Date', value: 'registrationDate',  sortable: false  },
            { text: 'More', value: 'name', align: 'center', sortable: false}
        ],
        mobileNumber: "",
        mobileChecker: [v => v.length == 10|| 'Mobile number must be valid'],
        address: {
            brgy : "",
            city : "",
            state : ""
        },
        tin: "",
        fullName: "",
        firstName: "",
        middleName: "",
        lastName: "",
        dealer: "",
        make: "",
        model: "",
        yearModel: null,
        yearModelMenu: false,
        dateOfPurchase: null,
        dateOfPurchaseMenu: false,
        registrationDate: null,
        registrationDateMenu: false,
        transactions: [],
        engineNumber: "",
        chassisNumber: "",
        odometer: "",
        plateNumber: "",
        updateNotification: false,
        countryCode: "+63",
        role: "",
        assign: "",
        progressDialog: false,
        userProfileDialog: false,
        motorcycleDetailsDialog: false,
        showAlert: false,
        alertColor: "",
        alertMessage: "",
        motorcycles: [],
        forChangeMotorcycle: {},
        editMotorcyleDialog: false,
        removeMotorcycleDialog: false,
        customers: [],
        selectedMotorcycle: {},
        motorcycleHistoryDialog: false,
        serviceHistory: [],
        classification: "",
        classifications: [],
        mcColor: "",
    }),
 
    methods : {
        goToPage(page) {
            this.$router.push("/"+page)
        },

        save(date) {
            this.$refs.yearModelMenu.save(date)
            this.$refs.picker.activePicker = "YEAR"
            this.yearModelMenu = false
        },

        async fetchWalkin() {
			let self = this
            self.customers = []
            await db.collection("WalkinCustomers"+self.$stage)
			.where("status","==","Completed").get().then(function(snapshot) {
				snapshot.forEach(function(doc) {
					self.customers.push(doc.data())
				})
			}).catch(error => console.log(error))
		},

        async fetchMcDetails() {
            let self = this
            self.motorcycles = []
            if(self.user){
                db.collection("McDetails"+self.$stage)
                    .onSnapshot(function(querySnapshot) {
                        self.motorcycles = []
                        querySnapshot.forEach(function(doc){
                            if(self.user.email==doc.data().email && doc.data().status=="1") {
                                self.motorcycles.push(doc.data())
                            }
                        })
                    })
            } 
        },

        refresh(){
            let self = this
            self.forChangeMotorcycle = {}
            self.motorcycleHistoryDialog = false
            self.removeMotorcycleDialog = false
            self.editMotorcyleDialog = false
            self.mcColor = ""
            self.dealer = ""
            self.make = ""
            self.model = ""
            self.yearModel = ""
            self.engineNumber = ""
            self.chassisNumber = ""
            self.odometer = ""
            self.plateNumber = ""
            self.dateOfPurchase = ""
            self.registrationDate = ""
            self.progressDialog = false
            self.userProfileDialog = false
            self.closeMotorcycleDialog()
        },

        showLoading(){
            let self = this
            self.progressDialog = true
        },

        async getRole() {
            let self = this
            if (self.user) {
                await firebase.auth().onAuthStateChanged(function(user) {
                    db.collection("Users"+self.$stage).doc(user.uid).get().then(function (doc) {
                        self.role = doc.data().role
                        self.firstName = doc.data().firstName
                        self.middleName = doc.data().middleName
                        self.lastName = doc.data().lastName
                        self.tin = doc.data().tin
                        self.mobileNumber = doc.data().mobileNumber
                        self.address = doc.data().address
                        self.assign = doc.data().assign
                        self.email = doc.data().email
                    }).then(function(res) {
                        if(self.mobileNumber == null || self.mobileNumber == "" && self.firstName == "" && self.lastName == "") {
                            self.updateNotification=true
                        } else {
                            self.updateNotification=false
                        }
                    }).then(function(){
                        self.fetchMcDetails()
                    }).catch(error => console.log(error))
                })
            }
        },

        viewHistory(mc) {
            let self = this 
            self.serviceHistory = []
            db.collection("McDetails"+self.$stage)
                // .where("engineNumber", "==", mc.engineNumber)
                .where("email", "==", self.user.email)
                .where("model", "==", mc.model)
                .get().then(function(querySnapshot){
                    if (querySnapshot.docs.length == 1) {
                        querySnapshot.forEach(function(doc) {
                            self.selectedMotorcycle = doc.data()
                        })
                    }
                }).then(function() {
                    self.motorcycleHistoryDialog = true
                    self.selectedMotorcycle.transactions.forEach(function(res) {
                        db.collection("ServiceBooking"+self.$stage).doc(res)
                            .get().then(function(services){
                                self.serviceHistory.push(services.data())
                            }).then(function(){
                                self.serviceHistory = (_.sortBy(self.serviceHistory, 'appointmentDate')).reverse()
                            })
                    })
                }).catch(error => console.log(error))
        },

        requestForChange(mc) {
            let self = this 
            db.collection("McDetails"+self.$stage)
                .where("email", "==", self.user.email)
                .where("model", "==", mc.model)
                .get().then(function(querySnapshot){
                    if (querySnapshot.docs.length == 1) {
                        querySnapshot.forEach(function(doc) {
                            self.forChangeMotorcycle = doc.data()
                        })
                    }
                }).then(function() {
                    self.editMotorcyleDialog = true
                }).catch(error => console.log(error))
        },

        updateMotorcycle(mc) {
            let self = this
            if (mc.make === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Make/Brand should not be blank"
                self.showAlert = true
            } else if (mc.model === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Model should not be blank"
                self.showAlert = true
            } else if (mc.classification === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Classification should not be blank"
                self.showAlert = true
            } else {
                self.showLoading()
                db.collection("McDetails"+self.$stage).doc(mc.id)
                .update({
                    "dealer": mc.dealer,
                    "make": mc.make,
                    "classification": mc.classification,
                    "model": mc.model,
                    "yearModel": mc.yearModel,
                    "color": mc.color,
                    "engineNumber": mc.engineNumber,
                    "chassisNumber": mc.chassisNumber,
                    "plateNumber": mc.plateNumber,
                    "odometer": mc.odometer,
                    "dateOfPurchase": mc.dateOfPurchase,
                    "registrationDate": mc.registrationDate,
                }).then(function() {
                    self.fetchMcDetails()
                    self.refresh()
                }).catch(error => console.log(error))
            }
        },

        deleteMotorcycleRequest(mc) {
            let self = this 
            db.collection("McDetails"+self.$stage)
                // .where("engineNumber", "==", mc.engineNumber)
                .where("email", "==", self.user.email)
                .where("model", "==", mc.model)
                .get().then(function(querySnapshot){
                    if (querySnapshot.docs.length == 1) {
                        querySnapshot.forEach(function(doc) {
                            self.forChangeMotorcycle = doc.data()
                        })
                    }
                }).then(function() {
                    self.removeMotorcycleDialog = true
                }).catch(error => console.log(error))
        },

        deleteMotorCycle(mc) {
            let self = this
            self.showLoading()
            db.collection("McDetails"+self.$stage).doc(mc.id)
            .update({
                "status": "0",
            }).then(function() {
                self.fetchMcDetails()
                self.refresh()
            }).catch(error => console.log(error))
        },

        saveMotorcycleDetails(){
            let self = this
            if (self.engineNumber === ""){
                self.alertColor = "red accent-4"
                self.alertMessage = "Engine number should not be blank"
                self.showAlert = true
            } else if (self.plateNumber === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Plate number should not be blank"
                self.showAlert = true
            } else if (self.dealer === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Dealer should not be blank"
                self.showAlert = true
            } else if (self.make === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Make/Brand should not be blank"
                self.showAlert = true
            } else if (self.model === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Model should not be blank"
                self.showAlert = true
            } else if (self.odometer === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Please input current kilometer mileage"
                self.showAlert = true
            } else if (self.yearModel === "" || self.yearModel === null) {
                self.alertColor = "red accent-4"
                self.alertMessage = "Year model should not be blank"
                self.showAlert = true
            } else if (self.classification === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Classification should not be blank"
                self.showAlert = true
            } else if (self.mcColor === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Color should not be blank"
                self.showAlert = true
            } else {
                self.showLoading()
                let timeStampId = new Date().getTime().toString()
                db.collection("McDetails"+self.$stage).doc(timeStampId).set({
                    "owner": self.user.fullName,
                    "email": self.user.email,
                    "mobile": self.user.mobileNumber,
                    "dealer": self.dealer,
                    "make": self.make,
                    "classification": self.classification,
                    "color": self.mcColor,
                    "model": self.model,
                    "yearModel": self.yearModel,
                    "engineNumber": self.engineNumber,
                    "chassisNumber": self.chassisNumber,
                    "plateNumber": self.plateNumber,
                    "odometer": self.odometer,
                    "dateOfPurchase": self.dateOfPurchase,
                    "registrationDate": self.registrationDate,
                    "transactions": self.transactions,
                    "status": "1",
                    "id": timeStampId
                }).then(function(res) {
                    self.fetchMcDetails()
                    self.refresh()
                }).catch(error => console.log(error))
            }
        },

        saveUserDetails() {
            let self = this
            let lists = []
            firebase.auth().onAuthStateChanged(function(user) {
                if(self.mobileNumber.length !== 10) {          
                    self.alertMessage = "Please input valid mobile number"
                    self.alertColor = "red accent-4"
                    self.showAlert =true
                } else if(self.firstName === "" || self.lastName === "") {
                    self.alertMessage = "First name and last name should not be blank. "
                    self.alertColor = "red accent-4"
                    self.showAlert =true
                } else if (self.address.brgy === "" || self.address.city === "" || self.address.state === "") {
                    self.alertMessage = "Please enter your complete address. "
                    self.alertColor = "red accent-4"
                    self.showAlert =true
                } else {
                    self.showLoading()
                    if (self.customers) {
                        self.customers = _.find(self.customers, {mobileNumber: self.mobileNumber})
                        if (self.customers) {
                            self.motorcycles = self.customers.motorcycles
                            db.collection('WalkinCustomers'+self.$stage)
                                .where('email','==',self.email)
                                .where('mobileNumber','==',self.mobileNumber)
                                .get().then(function(querySnapshot) {
                                querySnapshot.forEach(function(doc) {
                                    doc.ref.delete()
                                })
                            }).catch(error => console.log(error))
                        }
                    }

                    db.collection("Users"+self.$stage).doc(user.uid).update({
                        fullName: `${self.firstName} ${self.lastName}`,
                        firstName: self.firstName,
                        middleName: self.middleName,
                        lastName: self.lastName,
                        tin: self.tin,
                        countryCode: self.countryCode,
                        mobileNumber: self.mobileNumber,
                        email: self.email,
                        address: self.address,
                    }).then(function(doc) {
                        firebase.auth().onAuthStateChanged(function(user) {
                            if (user) {
                                let googleUser = {
                                    uid: user.uid,
                                    email: user.email,
                                    displayName: user.displayName,
                                    photoURL: user.photoURL,
                                }
                                self.$store.dispatch("setUser", googleUser).then(() => {
                                    user.getIdToken().then(function(accessToken) {
                                        self.$store.dispatch("setToken", accessToken).then(() => {
                                            self.$store.dispatch("setAuth", true).then(() => {
                                                db.collection("Users"+self.$stage).doc(user.uid)
                                                .onSnapshot(function(doc) {
                                                    self.$store.dispatch("setRole", doc.data().role).then(() => {}).catch(error => console.log(error))
                                                })
                                            }).catch(error => console.log(error))
                                        })
                                    })
                                })
                            } 
                        }, function(error) { console.log(error) })
                        if(self.mobileNumber == null || self.mobileNumber == "" && self.firstName == "" && self.lastName == "") {
                            self.updateNotification=true
                        } else {
                            self.updateNotification=false
                        }
                        self.closeProfileDialog()
                        self.refresh()
                    })
                }
            })
        },

        fetchBrands() {
            let self = this
            self.brands = []
            
            db.collection("Settings"+self.$stage).doc("Brands")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.brands.push(doc.data().brand)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        fetchDealers() {
            let self = this
            self.dealers = []
            
            db.collection("Settings"+self.$stage).doc("Dealers")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.dealers.push(doc.data().dealer)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        fetchClassification() {
            let self = this
            self.classifications = []
            
            db.collection("Settings"+self.$stage).doc("Classification")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.classifications.push(doc.data().classification)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        openProfileDialog() {
            this.userProfileDialog = true
        },
        closeProfileDialog() {
            this.userProfileDialog = false
        },
        openMotorcycleDialog() {
            this.$store.dispatch("setMotorcycle", true)
            this.motorcycleDetailsDialog = true
        },
        closeMotorcycleDialog() {
            this.$store.dispatch("setMotorcycle", false)
            this.motorcycleDetailsDialog = false
        },
    },

    mounted() {
        let self = this
        self.closeMotorcycleDialog()
        self.fetchBrands()
        self.fetchDealers()
        self.fetchClassification()
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                let googleUser = {
                    uid: user.uid,
                    email: user.email,
                    displayName: user.displayName,
                    photoURL: user.photoURL,
                }

                self.$store.dispatch("setUser", googleUser).then(() => {
                    user.getIdToken().then(function(accessToken) {
                        self.$store.dispatch("setToken", accessToken).then(() => {
                            self.$store.dispatch("setAuth", true).then(() => {
                                db.collection("Users"+self.$stage).doc(user.uid)
                                .onSnapshot(function(doc) {
                                    self.$store.dispatch("setRole", doc.data().role).then(() => {
                                        self.getRole()
                                    }).catch(error => console.log(error))
                                })
                            }).catch(error => console.log(error))	
                        })
                    })
                })
            } 
        })
    },

    watch: {
        yearModelMenu (val) {
            val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"))
        },

        yearModel (val) {
            let self = this
            if (val !== ""){
                self.yearModel = val.split('-')[0].trim()
            }
        },

        Auth: {
            handler: function(newValue) {
                let self = this
                if (self.Auth.motorcycleComponent == true) {
                    self.motorcycleDetailsDialog = true
                } else {
                    self.motorcycleDetailsDialog = false
                }
            },
            deep: true
        }
    },

    computed : {
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),
    }
}

</script>

<style scoped>

#drawer{
    background: rgb(12, 12, 12)
}
</style>